import {
  PlanTypeLiterals,
  ProductCodeTypeLiterals,
} from "../organization/org-product";
import {
  ProductDataRemovableProductCodeLiterals,
  ProductDataRemovalTask,
} from "./index";
import { NonTerminalStatuses } from "./index";

export const validateCreateTask = (
  productCode: ProductDataRemovableProductCodeLiterals,
  products: {
    productCode: ProductCodeTypeLiterals;
    plan: PlanTypeLiterals;
  }[],
  tasks: ProductDataRemovalTask[],
): { valid: boolean; errorMessage: string } => {
  const product = products.find(
    (product) => product.productCode === productCode,
  );
  if (!product) {
    return {
      valid: false,
      errorMessage: "製品設定がないため登録できません",
    };
  }
  if (product.plan !== "NotSet") {
    return {
      valid: false,
      errorMessage: "製品プランが有効なため登録できません",
    };
  }

  const activeTasks = tasks.filter((task) =>
    NonTerminalStatuses.includes(task.status),
  );
  if (activeTasks.length > 0) {
    return {
      valid: false,
      errorMessage: "有効な削除タスクがあるため登録できません",
    };
  }
  return { valid: true, errorMessage: "" };
};
